export const GET_LOCATION = 'GET_LOCATION';
export const SET_LOCATION = 'SET_LOCATION';
export const USER_LOCATION = 'user_location';
export const UPDATE_USER_LOCATION = 'update_user_location';
